import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClaimGuard, FeatureFlagGuard } from '@lsq-frontend/common-ui';
import { Routes } from '@lsq-frontend/common-ui';
import {
    customersNode,
    factoringAtlas,
    factoringNode,
    invoicesNode,
    reportsNode,
    insightsNode
} from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { ContactUsComponent } from '../contact-us/contact-us.component';
import { FactoringDashboardComponent } from '../factoring-dashboard/factoring-dashboard.component';
import { MobileUploadInvoicesComponent } from '../invoices/upload-invoices/mobile-upload-invoices/mobile-upload-invoices.component';
import { NoEulaGuard } from '@lsq-frontend/fasttrack-shared/features/eula-service';
import { UiRoutes } from '@lsq-frontend/angular-shared/app-constants';

export const appRoutes: Routes = [
    {
        path: UiRoutes.Home,
        component: FactoringDashboardComponent,
        canActivate: [NoEulaGuard],
        data: {
            title: factoringNode.title
        }
    },
    {
        path: reportsNode.path,
        loadChildren: () => import('../reports/reports.module').then((m) => m.ReportsModule),
        canActivate: [ClaimGuard, NoEulaGuard],
        data: {
            claims: reportsNode.claims
        }
    },
    {
        path: customersNode.path,
        loadChildren: () => import('../customers/customers.module').then((m) => m.CustomersModule),
        canActivate: [NoEulaGuard]
    },
    {
        path: invoicesNode.path,
        loadChildren: () => import('../invoices/invoices.module').then((m) => m.InvoicesModule),
        canActivate: [NoEulaGuard]
    },
    {
        path: factoringAtlas.REQUEST_FUNDS.path,
        loadChildren: () =>
            import('../request-funds/request-funds.module').then((m) => m.RequestFundsModule),
        canActivate: [ClaimGuard, NoEulaGuard],
        data: {
            claims: factoringAtlas.REQUEST_FUNDS.claims
        }
    },
    {
        path: factoringAtlas.INCREASE_CREDIT_LIMIT.path,
        loadChildren: () =>
            import('../increase-credit-limit/increase-credit-limit.module').then(
                (m) => m.IncreaseCreditLimitModule
            ),
        canActivate: [ClaimGuard, NoEulaGuard],
        data: {
            claims: factoringAtlas.INCREASE_CREDIT_LIMIT.claims
        }
    },
    {
        path: factoringAtlas.INVOICE_UPLOAD_HISTORY.path,
        loadChildren: () =>
            import('../invoices/invoice-upload-history/invoice-upload-history.module').then(
                (m) => m.InvoiceUploadHistoryModule
            ),
        canActivate: [ClaimGuard, NoEulaGuard],
        data: {
            claims: factoringAtlas.INVOICE_UPLOAD_HISTORY.claims
        }
    },
    {
        path: insightsNode.path,
        loadChildren: () => import('../insights/insights.module').then((m) => m.InsightsModule),
        canActivate: [ClaimGuard, NoEulaGuard, FeatureFlagGuard],
        data: {
            claims: insightsNode.claims,
            featureFlags: insightsNode.featureFlags
        }
    },
    {
        path: factoringAtlas.MOBILE_UPLOADS.path,
        component: MobileUploadInvoicesComponent,
        canActivate: [ClaimGuard, NoEulaGuard],
        data: {
            title: factoringAtlas.MOBILE_UPLOADS.title,
            claims: factoringAtlas.MOBILE_UPLOADS.claims
        }
    },
    {
        path: factoringAtlas.CONTACT_US.path,
        component: ContactUsComponent,
        canActivate: [ClaimGuard, NoEulaGuard],
        data: {
            title: factoringAtlas.CONTACT_US.title,
            claims: factoringAtlas.CONTACT_US.claims
        }
    },
    {
        path: UiRoutes.Wildcard,
        redirectTo: `/${UiRoutes.NotFound}`,
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [RouterModule.forChild(appRoutes)],
    exports: [RouterModule]
})
export class FactoringRoutingModule {}
